<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="mb-2">
            <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#add_performance_appraisal"
               class="btn btn-primary d-flex align-items-center" v-can="'PerformanceAppraisal.Create'">
              <i class="ti ti-circle-plus me-2"></i>Add Appraisal
            </a>
          </div>
          <div class="head-icons ms-2">
            <a href="javascript:void(0);" id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Filter (optional – wire to store.filters if desired) -->

      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Performance Appraisal List</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <review-table
              :rows="store.items"
              :loading="store.loading"
              @edit="openEdit"
              @delete="confirmDelete"
              @bulk-delete="bulkDelete"
            />
          </div>
          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>
              Showing page {{ store.pagination.current_page }} of {{ totalPages }}
            </div>
            <div class="btn-group">
              <button class="btn btn-outline-secondary"
                      :disabled="store.pagination.current_page <= 1"
                      @click="store.fetchAll({ page: store.pagination.current_page - 1 })">
                Prev
              </button>
              <button class="btn btn-outline-secondary"
                      :disabled="store.pagination.current_page >= totalPages"
                      @click="store.fetchAll({ page: store.pagination.current_page + 1 })">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a></p>
    </div>
  </div>

  <performance-appraisal-modal v-if="text !== 'Employee'" :edit-item="editItem" @saved="onSaved" />
</template>

<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, computed, onMounted, nextTick } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { useAppraisalStore } from "@/stores/appraisalStore";
import { useAuthStore } from "@/stores/authStore";
import ReviewTable from "./review-table.vue";
import PerformanceAppraisalModal from "@/components/modal/performance-appraisal-modal.vue";
import Modal from "bootstrap/js/dist/modal";

export default {
  components: { ReviewTable, PerformanceAppraisalModal },
  data() {
    const auth = useAuthStore();
    const roles = Array.isArray(auth.user?.roles) ? auth.user.roles : [];
    const isEmployee = roles.some((role) => {
      const name = typeof role === "string" ? role : role?.name;
      return name === "Employee";
    });

    return {
      title: isEmployee ? "My Performance Appraisals" : "Performance Appraisal",
      text: isEmployee ? "Employee" : "Performance",
      text1: isEmployee ? "My Performance Appraisals" : "Performance Appraisal",
    };
  },
  setup() {
    const store = useAppraisalStore();
    const dateRangeInput = ref(null);
    let editModal, deleteModal;
    const editItem = ref(null);

    function toggleHeader() {
      document.getElementById("collapse-header")?.classList.toggle("active");
      document.body.classList.toggle("header-collapse");
    }

    function booking_range(start, end) {
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    }

    const totalPages = computed(() => {
      const t = store.pagination.total || 0;
      const p = store.pagination.per_page || 25;
      return Math.max(1, Math.ceil(t / p));
    });

    function getOrCreateModal(el) {
      if (!el) return null;
      return Modal.getOrCreateInstance(el, { backdrop: true, keyboard: true });
    }

    function openEdit(row) {
      editItem.value = row;
      nextTick(() => {
        const el = document.getElementById("edit_performance_appraisal");
        editModal = getOrCreateModal(el);
        editModal?.show();
      });
    }

    async function confirmDelete(row) {
      editItem.value = row;
      await nextTick();
      const el = document.getElementById("delete_modal");
      deleteModal = getOrCreateModal(el);
      deleteModal?.show();
    }

    async function bulkDelete(ids) {
      if (!ids?.length) return;
      if (!confirm(`Delete ${ids.length} selected item(s)?`)) return;
      await store.bulkDelete(ids);
    }

    function onSaved() {
      editItem.value = null;
      store.fetchAll();
    }

    onMounted(() => {
      store.fetchAll();

      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();
        new DateRangePicker(dateRangeInput.value, {
          startDate: start,
          endDate: end,
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
          },
        }, booking_range);
        booking_range(start, end);
      }

      const editEl = document.getElementById("edit_performance_appraisal");
      editEl?.addEventListener("hidden.bs.modal", () => { editItem.value = null; });
    });

    return {
      store, dateRangeInput, toggleHeader, totalPages,
      openEdit, confirmDelete, bulkDelete, editItem, onSaved
    };
  },
};
</script>




